export function addCurrent(integrationservice) {
  return {
      type: 'ADD_CURRENT',
      integrationservice,
  }
}